import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Store } from '../../redux/Store';
import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import { Elements, StripeProvider } from 'react-stripe-elements';
import './Faq.css';


class Faq extends Component {
    constructor(props) {
        super(props)
        this.state = {
            body_class: ['apps-gotlocked-order', 'apps-gotlocked-faq']
        }
    }

    componentWillMount() {
        setTimeout(function() {
            if (document.body.classNameList) {
                document.body.classNameList.add(...this.state.body_class);
            } else {
                document.body.className = this.state.body_class.join(' ');
            }
            //document.getElementById('apps-gotlocked-menu').style.display = 'none';
        }.bind(this), 1);
    }

    componentWillUnmount() {
        document.body.className = '';
    }

    render() {
        return (
            <div>
                <section className="apps-gotlocked-faq-section section-padding" id="apps-gotlocked-faq">
                        <div className="container">
                            <Row>
                                <Col>
                                    <div className="apps-gotlocked-order-tbl-c">
                                        <div className="apps-gotlocked-order-content text-center">
                                            <h1>GotLocked FaQ</h1>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <br /><br />
                            <Row>
                                <Col>
                                    <div className="apps-gotlocked-accordion wow fadeIn" data-wow-delay="100ms">
                                        <div className="panel-group" id="accordion">
                                            <div className="panel panel-default">
                                                <div className="panel-heading">
                                                    <h4 className="panel-title click">
                                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse1" className="">How it works </a>
                                                    </h4>
                                                </div>
                                                <div id="collapse1" className="panel-collapse collapse in">
                                                    <div className="panel-body">Gotlocked offers a quick and easy way to find a professional locksmith in your area in just 2 steps: <br />
                                                        <ul>
                                                            <li>Enter your details and find which locksmiths are available in your area. </li>
                                                            <li>Easily choose a locksmith by checking out reviews, comments and price quotations all in one place. 
                                                        Once you find an option you are happy with, you can go ahead and book the service. </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel panel-default">
                                                <div className="panel-heading">
                                                    <h4 className="panel-title">
                                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse2" className="collapsed">Customer Service</a>
                                                    </h4>
                                                </div>
                                                <div id="collapse2" className="panel-collapse collapse">
                                                    <div className="panel-body">Our goal is to make your search for locksmith services as easy as possible. Our customer care is here to help you with any question you might have. All of the technicians we work with, are trained professionals that strive to give you the best service for a great price. Please don’t hesitate to reach out to us for any question via email/phone/chat.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel panel-default">
                                                <div className="panel-heading">
                                                    <h4 className="panel-title">
                                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse3" className="collapsed">The Locksmiths:</a>
                                                    </h4>
                                                </div>
                                                <div id="collapse3" className="panel-collapse collapse">
                                                    <div className="panel-body">The Technicians we work with are highly skilled, fully licensed, certified and insured professionals. They will be able to provide you the best, quickest and most efficient service.</div>
                                                </div>
                                            </div>
                                            <div className="panel panel-default">
                                                <div className="panel-heading">
                                                    <h4 className="panel-title">
                                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse4" className="collapsed">Locksmith Services</a>
                                                    </h4>
                                                </div>
                                                <div id="collapse4" className="panel-collapse collapse">
                                                    <div className="panel-body">Through our app you can find car, residential and commercial locksmith services</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                </section>
            </div >
        );
    }
}

export default Faq;